import React from 'react';
import { CommonEmbed } from 'components/common/CommonEmbed';

export const Terms: React.FC = () => {
    return <CommonEmbed title="이용약관" path="/terms" />;
};
